import { render } from "./Sap.vue?vue&type=template&id=7a4079f7&ts=true"
import script from "./Sap.vue?vue&type=script&lang=ts"
export * from "./Sap.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__